import { createContext } from 'react';
import { UseCurrentAccessPolicyReturn } from '@hooks/useCurrentAccessPolicy';

// -----------------------------------------------------------------------------
interface AccessPolicyContextType extends UseCurrentAccessPolicyReturn {}

// -----------------------------------------------------------------------------
export const AccessPolicyContext = createContext<
  AccessPolicyContextType | undefined
>(undefined);
